<div class="ion-page">
  <ion-header>
    <ion-toolbar color="secondary">
      <ion-title style="text-align: center;">
        @if (showBasicFields) {
          {{ (isEditMode ? 'Edit Category Title' : 'New Category Title') | translate }}
        }
        @if (!showBasicFields) {
          {{ 'Manage Embed Config' | translate }}
        }
      </ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" (click)="dismiss()">
          <ion-icon name="close" style="color: var(--ion-color-secondary-contrast);"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <div>
      <form [formGroup]="renameForm">

        <!-- Basic Information Section (editable) -->
        @if (showBasicFields) {
          <ion-card [style.box-shadow]="portalVersion !== 'V2' ? 'none' : null" [style.border]="portalVersion !== 'V2' ? 'none' : null">
            @if (portalVersion === 'V2') {
              <ion-card-header>
                <ion-card-title style="display: flex; align-items: center; gap: 8px; color: var(--ion-color-secondary-contrast);">
                  <ion-icon name="information-circle-outline" class="section-icon"></ion-icon>
                  <span>{{ 'Basic Information' | translate }}</span>
                </ion-card-title>
              </ion-card-header>
            }
            <ion-card-content [style.padding]="portalVersion !== 'V2' ? '0' : null">
              <!-- Title -->
              <ion-item lines="none" [class.item-has-error]="renameForm.get('newTitle')?.errors && isSubmitted">
                <ion-label position="stacked"><span>{{ 'Title' | translate }}</span> <span style="color: var(--ion-color-danger);">*</span></ion-label>
                <ion-input type="text" formControlName="newTitle" placeholder="{{ 'Enter title' | translate }}" autocomplete="off" maxlength="36"
                  [class.ion-invalid]="renameForm.get('newTitle')?.hasError('required') && isSubmitted"
                  [class.ion-touched]="isSubmitted"
                  [errorText]="'This field is required' | translate"></ion-input>
                <ion-note slot="helper" style="opacity: 0.6;">{{ (renameForm.get('newTitle')?.value?.length || 0) }}/36</ion-note>
              </ion-item>
              <!-- Description -->
              @if (portalVersion === 'V2') {
                <ion-item lines="inset">
                  <ion-label position="stacked">{{ 'Description' | translate }}</ion-label>
                  <ion-textarea formControlName="description" [autoGrow]="true" rows="3" placeholder="{{ 'Enter description' | translate }}" maxlength="70"></ion-textarea>
                  <ion-note slot="helper" style="opacity: 0.6;">{{ (renameForm.get('description')?.value?.length || 0) }}/70</ion-note>
                </ion-item>
              }
              <!-- Published -->
              @if (portalVersion === 'V2') {
                <ion-item lines="none">
                  <ion-label>
                    <h3>{{ 'Published' | translate }}</h3>
                    <p>{{ 'Make this category title visible to users' | translate }}</p>
                  </ion-label>
                  <ion-checkbox formControlName="published" slot="end" style="margin-right: 1em"></ion-checkbox>
                </ion-item>
              }
            </ion-card-content>
          </ion-card>
        }

        <!-- Basic Information Section (read-only, shown when only EmbedConfig is editable) -->
        @if (!showBasicFields) {
          <ion-card style="opacity: 0.5; pointer-events: none;">
            <ion-card-header>
              <ion-card-title style="display: flex; align-items: center; gap: 8px; color: var(--ion-color-secondary-contrast);">
                <ion-icon name="information-circle-outline" class="section-icon"></ion-icon>
                <span>{{ 'Basic Information' | translate }}</span>
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="inset">
                <ion-label position="stacked">{{ 'Title' | translate }}</ion-label>
                <ion-input type="text" formControlName="newTitle" readonly="true"></ion-input>
              </ion-item>
              <ion-item lines="inset">
                <ion-label position="stacked">{{ 'Description' | translate }}</ion-label>
                <ion-textarea formControlName="description" readonly="true" [autoGrow]="true" rows="3"></ion-textarea>
              </ion-item>
              <ion-item lines="none">
                <ion-label>
                  <h3>{{ 'Published' | translate }}</h3>
                </ion-label>
                <ion-checkbox formControlName="published" slot="end" style="margin-right: 1em;" [disabled]="true"></ion-checkbox>
              </ion-item>
            </ion-card-content>
          </ion-card>
        }

        <!-- Category Logo Section -->
        @if (showBasicFields && portalVersion === 'V2') {
          <ion-card>
            <ion-card-header>
              <ion-card-title style="display: flex; align-items: center; gap: 8px; color: var(--ion-color-secondary-contrast);">
                <ion-icon name="image-outline" class="section-icon"></ion-icon>
                <span>{{ 'Category Logo' | translate }}</span>
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="inset">
                <ion-label position="stacked">{{ 'Category Logo (icon name)' | translate }}</ion-label>
                <div style="display: flex; align-items: center; gap: 12px; width: 100%; margin-top: 4px;">
                  @if (renameForm.get('sectionLogo')?.value) {
                    <ion-icon
                      [name]="$safeNavigationMigration(renameForm.get('sectionLogo')?.value)"
                      style="font-size: 1.6rem; flex-shrink: 0; color: var(--ion-color-secondary-contrast);">
                    </ion-icon>
                  }
                  @if (!renameForm.get('sectionLogo')?.value) {
                    <ion-icon
                      name="image-outline"
                      style="font-size: 1.6rem; flex-shrink: 0; opacity: 0.3;">
                    </ion-icon>
                  }
                  <ion-select formControlName="sectionLogo" placeholder="{{ 'Select an icon' | translate }}" interface="popover" style="flex: 1;">
                    @for (icon of iconOptions; track icon) {
                      <ion-select-option [value]="icon">{{ icon }}</ion-select-option>
                    }
                  </ion-select>
                </div>
              </ion-item>
              <ion-item lines="none" style="margin-top: 12px;">
                <ion-label position="stacked"><span>{{ 'Logo Color' | translate }}</span></ion-label>
                <div style="display: flex; align-items: center; gap: 10px; margin-top: 8px; width: 100%;">
                  <input type="color"
                    [value]="renameForm.get('logoColor')?.value || '#000000'"
                    (input)="renameForm.get('logoColor')?.setValue($any($event.target).value)"
                    style="width: 40px; height: 36px; border: none; background: none; cursor: pointer; padding: 0; flex-shrink: 0;" />
                    <ion-input type="text" formControlName="logoColor"
                      placeholder="#000000 or color name"
                      style="flex: 1;"
                      autocomplete="off">
                    </ion-input>
                  </div>
                </ion-item>
              </ion-card-content>
            </ion-card>
          }

          <!-- Sub Titles Section -->
          @if (showBasicFields && portalVersion === 'V2') {
            <ion-card>
              <ion-card-header>
                <ion-card-title style="display: flex; align-items: center; gap: 8px; color: var(--ion-color-secondary-contrast);">
                  <ion-icon name="list-outline" class="section-icon"></ion-icon>
                  <span>{{ 'Sub Titles' | translate }}</span>
                  <span style="font-size: 0.75rem; font-weight: 400; opacity: 0.6; margin-left: 4px;">({{ subTitlesArray.length }}/3)</span>
                  <ion-button size="small" (click)="addSubTitle()" [disabled]="subTitlesArray.length >= 3" style="margin-left: auto; background: var(--ion-color-tertiary); color: var(--ion-color-secondary-contrast);">
                    <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                    <label>{{'Add' | translate}}</label>
                  </ion-button>
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ng-container formArrayName="subTitles">
                  @for (ctrl of subTitlesArray.controls; track ctrl; let i = $index) {
                    <ion-item lines="none" [class.item-has-error]="ctrl.errors && isSubmitted">
                      <ion-input type="text" [formControlName]="i" placeholder="{{ 'Sub title' | translate }}" autocomplete="off" maxlength="28"
                        [class.ion-invalid]="ctrl.hasError('required') && isSubmitted"
                        [class.ion-touched]="isSubmitted"
                        [errorText]="'This field is required' | translate"></ion-input>
                      <ion-note slot="helper" style="opacity: 0.6;">{{ (ctrl.value?.length || 0) }}/28</ion-note>
                      <ion-button slot="end" size="small" fill="clear" color="danger" (click)="removeSubTitle(i)">
                        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                      </ion-button>
                    </ion-item>
                  }
                </ng-container>
                @if (subTitlesArray.length === 0) {
                  <ion-text style="font-size: 0.85rem; opacity: 0.6;">{{ 'No sub titles added' | translate }}</ion-text>
                }
              </ion-card-content>
            </ion-card>
          }

          <!-- Embed Config Section -->
          @if (showEmbedConfig && isEditMode) {
            <ion-card>
              <ion-card-header>
                <ion-card-title style="display: flex; align-items: center; gap: 8px; color: var(--ion-color-secondary-contrast);">
                  <ion-icon name="link-outline" class="section-icon"></ion-icon>
                  <span>{{ 'Embed Config' | translate }}</span>
                  @if (embedConfigArray.length > 0) {
                    <ion-badge style="margin-left: 4px; background: var(--ion-color-medium);">{{ embedConfigArray.length }}</ion-badge>
                  }
                  <ion-button size="small" fill="solid" color="medium" (click)="addEmbedConfig()" style="margin-left: auto;">
                    <ion-icon name="add-outline" slot="start"></ion-icon>
                    <span>{{ 'Add' | translate }}</span>
                  </ion-button>
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <ng-container formArrayName="embedConfig">
                  @for (ctrl of embedConfigArray.controls; track ctrl; let i = $index) {
                    <div [formGroupName]="i" class="embed-config-item">
                      <div class="embed-config-header">
                        <div class="embed-config-badge">
                          <ion-icon name="link-outline"></ion-icon>
                          <span>{{ 'Config' | translate }} {{ i + 1 }}</span>
                        </div>
                        <ion-button size="small" fill="clear" color="danger" (click)="removeEmbedConfig(i)">
                          <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                      </div>
                      <div class="embed-config-fields">
                        <ion-item lines="inset" class="embed-field">
                          <ion-icon name="pricetag-outline" slot="start" class="field-icon"></ion-icon>
                          <ion-label position="stacked">{{ 'Label' | translate }}</ion-label>
                          <ion-input type="text" formControlName="Label" placeholder="{{ 'Enter label' | translate }}" autocomplete="off"></ion-input>
                        </ion-item>
                        <ion-item lines="inset" class="embed-field">
                          <ion-icon name="globe-outline" slot="start" class="field-icon"></ion-icon>
                          <ion-label position="stacked">{{ 'URL' | translate }}</ion-label>
                          <ion-textarea formControlName="Url" placeholder="https://..." [autoGrow]="true" rows="3" autocomplete="off" autocorrect="off" spellcheck="false" style="word-break: break-all; font-size: 1rem;"></ion-textarea>
                        </ion-item>
                      </div>
                      <ion-item lines="none" class="embed-pinned-item">
                        <ion-label>
                          <h3>{{ 'Pinned' | translate }}</h3>
                          <p>{{ 'Pin this embed to the top for all users' | translate }}</p>
                        </ion-label>
                        <ion-checkbox formControlName="Pinned" slot="end" style="margin-right: 1em"></ion-checkbox>
                      </ion-item>
                      <div class="embed-option-section">
                        <p class="embed-option-label">{{ 'Embed Option' | translate }}</p>
                        <ion-radio-group formControlName="EmbedOption" class="embed-radio-group">
                          <div class="radio-option" [class.embed-radio-selected]="ctrl.get('EmbedOption')?.value === 'iframe'">
                            <ion-item lines="none">
                              <ion-icon name="browsers-outline" slot="start" class="radio-icon"></ion-icon>
                              <ion-label>{{ 'Iframe' | translate }}</ion-label>
                              <ion-radio slot="end" value="iframe"></ion-radio>
                            </ion-item>
                          </div>
                          <div class="radio-option" [class.embed-radio-selected]="ctrl.get('EmbedOption')?.value === 'newpage'">
                            <ion-item lines="none">
                              <ion-icon name="open-outline" slot="start" class="radio-icon"></ion-icon>
                              <ion-label>{{ 'Open new page' | translate }}</ion-label>
                              <ion-radio slot="end" value="newpage"></ion-radio>
                            </ion-item>
                          </div>
                        </ion-radio-group>
                      </div>
                      <div class="embed-image-section">
                        <p class="embed-option-label">{{ 'Preview Image' | translate }}</p>
                        @if (embedImageResponses.get(i)?.ImageURI || ctrl.get('ImageURI')?.value) {
                          <div class="embed-image-preview">
                            <ion-img [src]="embedImageResponses.get(i)?.ImageURI || ctrl.get('ImageURI')?.value" alt="Embed preview"></ion-img>
                          </div>
                        }
                        <br>
                          <ion-button class="embed-upload-btn" expand="block">
                            <input type="file" class="inputfile" accept="image/png,image/jpeg,image/jpg" (change)="uploadEmbedImage($event, i)" />
                            <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
                            <ion-label>{{ 'Upload Image' | translate }}</ion-label>
                          </ion-button>
                        </div>
                      </div>
                    }
                  </ng-container>
                  @if (embedConfigArray.length === 0) {
                    <div class="embed-empty-state">
                      <ion-icon name="link-outline" class="embed-empty-icon"></ion-icon>
                      <p>{{ 'No embed configs added' | translate }}</p>
                    </div>
                  }
                </ion-card-content>
              </ion-card>
            }

          </form>
          <!-- Action Buttons -->
          <div >
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-button color="tertiary" expand="block" (click)="dismiss()">{{ 'Cancel' | translate }}</ion-button>
                </ion-col>
                <ion-col>
                  <ion-button color="medium" expand="block" (click)="submit()" [disabled]="isProcessing">
                    @if (isProcessing) {
                      <ion-spinner name="dots" slot="start"></ion-spinner>
                    }
                    {{ (isEditMode ? 'Save' : 'Create') | translate }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>

        </div>
      </ion-content>
    </div>
